<template>
    <div>
      <autoLogout />
      <loader :loader="loader || sending" />
      <div class="wrapper-content">
        <encabezado
          :elementos="encabezado"
          :nameRoute="nameRoute"
          :paramsRoute="paramsRoute"
        />
        <v-card>
          <v-card-text>
            <v-container>
              <v-row dense v-if="info && info.idPatient">
                <v-col>
                  <patient-information :model="info" @patientLoaded="handlePatientLoaded" />
                </v-col>
              </v-row>
              <!-- <v-row dense class="ml-2">
                <v-col md="4" sm="12" cols="12" v-if="info.phone">
                  <strong>Teléfono móvil: </strong>
                  {{ info.phone || "N/A" }}</v-col
                >
                <v-col md="4" sm="12" cols="12" v-if="info.homePhone">
                  <strong>Teléfono fijo: </strong>
                  {{ info.homePhone || "N/A" }}
                </v-col>
                <v-col md="4" sm="12" cols="12" v-if="info.email">
                  <strong>Correo electrónico: </strong>
                  {{ info.email || 'N/A' }}
                </v-col>
              </v-row>
              <v-row dense class="ml-2" v-if="info.address">
                <v-col md="12" sm="12" cols="12">
                  <strong>Dirección: </strong>
                  {{ info.address }}
                </v-col>
              </v-row> -->
              <v-row dense v-if="info && info.idStudy">
                <v-col>
                  <study-information :model="info" />
                </v-col>
              </v-row>
                        <!-- 1) RESULTADOS DEL ESTUDIO CITOLÓGICO -->
              <v-row class="align-center mb-3">
                <!-- Etiqueta a la izquierda -->
                  <v-col cols="12" sm="4" md="4" lg="3" class="text-right">
                    <span class="font-weight-bold"
                     >Resultados del estudio citológico:</span
                   >
                 </v-col>
  
                <v-col cols="12" sm="8" md="8" lg="9">
                  <v-select
                    v-model="resultsCytology"
                    :items="listResultsCytology"
                    placeholder="Seleccionar una opción"
                    solo
                    hide-details
                    dense
                    :disabled="isReadOnly"
                  />
                </v-col>
              </v-row>
  
              <!-- 2) HALLAZGOS ADICIONALES -->
              <v-row class="align-center mb-3">
                <v-col cols="12" sm="4" md="4" lg="3" class="text-right">
                  <span class="font-weight-bold">Hallazgos adicionales:</span>
                </v-col>
                <v-col cols="12" sm="8" md="8" lg="9">
                  <v-select
                    v-model="additionalFindings"
                    :items="listAdditionalFindings"
                    placeholder="Seleccionar una opción"
                    solo
                    hide-details
                    dense
                    :disabled="isReadOnly"
                  />
                </v-col>
              </v-row>
  
              <!-- 3) OTRAS ALTERACIONES -->
              <v-row class="align-center" v-if="showOtherAlterations">
                <v-col cols="12" sm="4" md="4" lg="3" class="text-right">
                  <span class="font-weight-bold"
                    >Otras Alteraciones (especifique):</span
                  >
                </v-col>
                <v-col cols="12" sm="8" md="8" lg="9">
                  <v-text-field
                    v-model="otherAlterations"
                    label="Otras Alteraciones"
                    clearable
                    :disabled="isReadOnly"
                  />
                </v-col>
              </v-row>
  
              <h4 class="font-weight-bold mb-4" style="margin-top: 20px;">
                {{ categoryName }}
              </h4>
  
                <v-data-table
                  :headers="headersBioMolecular"
                  :items="itemsBioMolecular"
                  hide-default-footer
                  dense
                 >
                <template v-slot:[`item.parametro`]="{ item }">
                  {{ item.parametro }}
                </template>
  
                <template v-slot:[`item.resultado`]="{ item }">
                  <v-select
                    v-model="item.resultadoSelected"
                    :items="item.referenceResults"
                    item-text="value"
                    item-value="value"
                    hide-details
                    dense
                    outlined
                    placeholder="Seleccione..."
                    :disabled="isReadOnly"
                  />
                </template>
  
                <template v-slot:[`item.unidad`]="{ item }">
                  {{ item.unidad || "–––" }}
                </template>
  
                <template v-slot:[`item.referencia`]="{ item }">
                  <span
                    v-if="item.referenceValues && item.referenceValues.length"
                  >
                    <span
                      v-for="(refVal, idx) in item.referenceValues"
                      :key="idx"
                    >
                      {{ refVal.value }}
                    </span>
                  </span>
                  <span v-else>–––</span>
                </template>
              </v-data-table>
  
              <v-row class="ml-2 mt-7" align="center">
                <v-col md="4" offset="2">
                  <v-text-field
                    v-model="metodo"
                    :counter="200"
                    label="Método"
                    required
                    prepend-icon="mdi-pencil-remove-outline"
                    autocomplete="off"
                    disabled
                  />
                </v-col>
                <v-col md="4">
                  <v-text-field
                    v-model="muestra"
                    :counter="200"
                    label="Muestra"
                    required
                    prepend-icon="mdi-file-document"
                    autocomplete="off"
                    disabled
                  />
                </v-col>
              </v-row>
  
            <v-col cols="12">
                <h3>Observaciones</h3>
            </v-col>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                name="Observaciones"
                rules="required"
              >
                <v-textarea
                  v-model="finalObservation"
                  outlined
                  auto-grow
                  :error-messages="errors"
                  label="Observaciones"
                  rows="6"
                  class="mb-4"
                  :disabled="isReadOnly"
                />
              </validation-provider>
            </v-col>

            
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col cols="6">
                <h3 class="font-weight-black mb-5" align="center" >Adjuntar archivos</h3>
          
                <!-- Input de archivos -->
                <v-row align="center" justify="center">
                  <v-col cols="8">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Adjuntar archivos"
                       rules="required"
                        ref="filesProvider"
                    >
                      <v-file-input
                        v-model="newPapFiles"
                        placeholder="Seleccione los archivos"
                        label="Adjuntar archivos"
                        accept=".pdf,application/pdf"
                        show-size
                        counter
                        prepend-icon="mdi-paperclip"
                        :disabled="isReadOnly"
                        :error-messages="errors"
                         @change="handleFileChange"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
  
                    <!-- Vista previa de archivos -->
                <v-row class="d-flex flex-nowrap" align="start" justify="center">
                  <v-col
                    cols="3"
                    class="text-center"
                    v-for="(file, index) in papFilesAll"
                    :key="index"
                  >
                    <template v-if="isPdf(file.fileName)">
                      <!-- PDFs -->
                      <v-icon size="100px" color="red">mdi-file-pdf-box</v-icon>
                      <h3 style="font-size: 100%; text-align: center">{{ file.fileName }}</h3>
                      <v-btn small color="primary" @click="openPdf(file)">Ver PDF</v-btn>
                    </template>
                    <v-btn
                      v-if="mode === 'edit'"
                      small
                      color="red"
                      class="mt-2"
                      @click="removePapFile(index)"
                    >
                      <v-icon>mdi-delete</v-icon> Eliminar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row align="center" justify="center">
              <v-col cols="10" class="text-center my-3">
                <v-btn
                  color="error"
                  outlined
                  @click="$router.go(-1)"
                  class="mr-8"
                >
                  <v-icon left>mdi-chevron-left</v-icon>
                  Volver
                </v-btn>
                <v-btn
                  v-if="mode === 'edit'"
                  color="primary"
                  outlined
                  @click="editPap"
                  :disabled="
                            sending ||
                            papFilesAll.length === 0 ||
                            fileTooLarge
                          "
                  >
                  <v-icon left>mdi-content-save</v-icon>
                  Editar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </template>
  <script>
  import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
  import StudyInformation from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
  import moment from "moment";
  import Datatable from "@/components/Datatable.vue";
  import Encabezado from "@/app/components/base/header/Header.vue";
  import BtnAccion from "@/components/btnAccion.vue";
  import {
    StudyRequest,

  } from "@/core/request";
  import AutoLogout from "@/components/AutoLogout.vue";
  import Loader from "@/components/Loader.vue";
  import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  
  extend("required", {
    ...required,
    message: "{_field_} no puede quedar vacío",
  });
  
  import ViewImageButton from "@/app/components/common/study/ViewImageButton.vue";
  
 const mapAnswers = (answers = []) => {
  return answers.map(ans => ({
    text: ans.name,
    value: ans.idAnswer,
  }));
};

  export default {
    name: "EditarEstudio",
    components: {
      PatientInformation,
      StudyInformation,
      Encabezado,
      Datatable,
      BtnAccion,
      AutoLogout,
      Loader,
      ValidationObserver,
      ValidationProvider,
      ViewImageButton,
    },
    data() {
      return {
        nameRoute: "IniciarEstudio",
        sending: false,
        loader: false,
        paramsRoute: {},
        prevRoute: null,
        encabezado: {},
        item: {},
        info: {
        idPerson: null, 
      },
      otherAlterations: "",
      showOtherAlterations: false,
      isReadOnly: this.$route.meta.isReadOnly,
      service: StudyRequest,
        reasonRules: [(v) => !!v || "El motivo de la cancelación es obligatorio"],
        quantityImages: 0,
        quantity: 1,
        dataModal: "",
        headersBioMolecular: [
        { text: "Parámetro", value: "parametro", align: "left" },
        { text: "Resultado", value: "resultado", align: "left" },
        { text: "Unidad", value: "unidad", align: "left" },
        { text: "V. Referencia", value: "referencia", align: "left" },
      ],
        resultsCytology: null,
        papFilesList: [],
        papFiles: [],
        papFilesAll: [],
        newPapFiles: [],
        fileTooLarge: false,
        isViewPapForm: false,
        finalObservation: "",
        showOtherAlterations: false,
        additionalFindings: null,
        listResultsCytology: [],
        listAdditionalFindings: [],
        itemsBioMolecular: [],
        categoryName: "",
        metodo: "",
        muestra: "",
      };
    },
    created() {
  const id = this.$route.params.idStudy;
  if (!id) {
    console.error("No se ha recibido un idStudy en la ruta");
    return;
  }
  this.info = { idStudy: id };
  this.getPapData();
  this.getPapReport();
},
    beforeMount() {
      this.getStudy();
    },
    watch: {
    "info.idPerson"(newId) {
      if (newId) {
        this.getPapData();
      }
    },
    additionalFindings(newVal) {
      const selected = this.listAdditionalFindings.find(
        (item) => item.value === newVal
      );
      this.showOtherAlterations =
        selected?.text === "Otras Alteraciones (especifique)";
      if (!this.showOtherAlterations) {
        this.otherAlterations = "";
      }
    },
  },
  computed: {
    mode() {
      return this.$route.meta.isReadOnly ? 'readOnly' : 'edit';
    }
  },
    methods: {
      catchError: (e) => {
        //console.log(e);
        this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
      },
      getStudy() {
        this.sending = true;
        const id = this.$route.params.idStudy;
        let post = {
          idStudy: id,
        };
        StudyRequest.getStudy(post).then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.item = res.data.data;
            let address = `${this.item.address.street} #${this.item.address.outdoorNumber},
            ${this.item.address.colonyKey}, ${this.item.address.municipalityKey},
            ${this.item.address.federalEntityKey}, ${this.item.address.postalCode}`;
            address = address
              .replace("null", "")
              .replace("  ", " ")
              .replace("\n", " ")
              .replace("\n ", " ");
            let birthDate =
              moment(new Date(this.item.birthDate))
                .locale("es")
                .format("DD/MM/YYYY") || "---";
  
            this.info = {
              idPatient: this.item.idPatient,
              idStudy: this.item.idStudy,
              fullNamePatient: this.item.fullNamePatient,
              gender: this.item.sexPatient,
              curp: this.item.curpPatient,
              birthDate: birthDate,
              address: address,
              phone: this.item.phoneNumber,
              homePhone: this.item.homePhone,
              email: this.item.email,
              studyModality: this.item.nameStudy,
              modality: this.item.nameModality,
              status: this.item.status,
              statusInterpretation: this.item.statusInterpretation || 0,
              accessionNumber: this.item.accessionNumber,
              registrationDate:
                moment(new Date(this.item.registrationDateStudy))
                  .locale("es")
                  .format("DD/MM/YYYY HH:mm") || "---",
              nacPatient:
                moment(new Date(this.item.birthDate))
                  .locale("es")
                  .format("DD/MM/YYYY") || "---",
              sexPatient: this.item.sexPatient,
              age: this.$utilFront.obtainAgeWithLabel(this.item.birthDate),
              laboratoryLabel: this.item.laboratoryLabel,
            };
          } else if (res.data.code === 401) {
            this.unauthorized();
          }
        }).finally(()=>{
          this.sending = false;
        });
      },

async getPapData() {
  this.sending = true;
  try {
    const idPerson = this.info.idPerson;
    if (!idPerson) {
      console.error("No se encontró idPerson");
      return;
    }

    const payload = {
      evaluationTypes: [14],
      idStudy: this.$route.params.idStudy,
      idPerson: idPerson,
    };

    const papForm = await StudyRequest.papanicolaouForm(payload);

    if (papForm?.data?.length) {
      const questions = papForm.data[0].dataQuestions ?? [];
      questions.forEach((question) => {
        if (question.name === "Resultados del estudio citológico") {
          this.listResultsCytology = mapAnswers(question.answers);
          this.resultsCytology = question.idAnswer ?? "";
        }
        if (question.name === "Hallazgos adicionales") {
          this.listAdditionalFindings = mapAnswers(question.answers);
          this.additionalFindings = question.answersClosed?.[0] ?? "";
        }
      });
    }

    const payloadTable = { idStudy: this.item.idStudy };
    const tableResp = await StudyRequest.papanicolaouTable(payloadTable);

    if (tableResp?.data?.data) {
      const data = tableResp.data.data;
      this.finalObservation = data.finalObservation ?? "";

      const category = data.categories[0];
      this.categoryName = category.name;

      this.itemsBioMolecular = category.parameters.map((param) => ({
        idParameter: param.idParameter,
        parametro: param.name,
        referenceValues: param.referenceValues,
        referenceResults: param.referenceResults,
        resultadoSelected: param.result?.result ?? null,
        unidad: param.unitMeasurement ?? "",
      }));
      this.metodo = category.method ?? "";
      this.muestra = category.sample ?? "";
    }
  if (papForm?.data?.length) {
    papForm.data[0].dataQuestions.forEach((question) => {
      if (question.idQuestion === "QGIN-24") {
  if (question.answersClosed && question.answersClosed.includes("AGIN-99")) {
    this.additionalFindings = "AGIN-99";
    this.showOtherAlterations = true;
    this.otherAlterations = question.answerOpen || question.answerClosed || "";
  } else {
    this.showOtherAlterations = false;
    this.otherAlterations = "";
  }
}
    });
  }
  } catch (error) {
    console.error("Error al obtener datos PAP:", error);
    this.$utilFront.notifications(
      "Error al cargar información del estudio Papanicolaou.",
      "ERROR"
    );
  } finally {
    this.sending = false;
  }
},
async editPap() {
  this.sending = true;
  try {
    await this.updatePapForm();
    await this.updateBioResults();
    await this.uploadNewPapFiles();

    this.$utilFront.notifications(
      "Consulta editada correctamente",
      "SUCCESS"
    );

    this.goBack();
  } catch (error) {
    console.error("Error al editar el formulario Papanicolaou:", error);
    this.$utilFront.notifications(
      "Ocurrió un error al guardar los cambios.",
      "ERROR"
    );
    throw error;
  } finally {
    this.sending = false;
  }
},


  async updatePapForm() {
    const questions = [
      {
        idQuestion: "QGIN-23",
        idAnswer: this.resultsCytology,
      },
      {
        idQuestion: "QGIN-24",
        answersClosed: this.additionalFindings
          ? [this.additionalFindings]
          : [],
        openAnswer:
          this.additionalFindings === "AGIN-99" && this.otherAlterations?.trim()
            ? this.otherAlterations.trim()
            : undefined,
      },
    ]

    const payload = {
      calculators: [{ idCalculator: "EGIN-03", dataQuestions: questions }],
      idStudy: this.$route.params.idStudy,
      idPerson: this.info.idPerson,
    }

    const resp = await StudyRequest.papanicolaouEditForm(payload)
    if (resp.status !== 200) {
  
      throw new Error("EditForm failed")
    }
    
  },

  async updateBioResults() {
    const results = this.itemsBioMolecular.map(item => ({
      idResults: null,
      result: item.resultadoSelected,
      idParameter: item.idParameter,
    }))

    const payload = {
      idHumanResource: this.$utilFront.getIdHumanResource(),
      idStudy: this.$route.params.idStudy,
      observation: this.finalObservation,
      idStudyResults: null,
      results,
    }

    const resp = await StudyRequest.papanicolaouEditTable(payload)
    if (resp.status !== 200) {
      
      throw new Error("EditTable failed")
    }
    
  },

  async uploadNewPapFiles() {
  const newFiles = this.papFilesAll.filter(f => !f.fromBackend && f.file)
  if (newFiles.length === 0) return

  const formData = new FormData()
  formData.append(
    "jsonData",
    JSON.stringify({ idStudy: this.$route.params.idStudy })
  )
  for (const { file, fileName } of newFiles) {
    formData.append("files", file, fileName)
  }

  const resp = await StudyRequest.papanicolaouSaveFiles(formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })

  if (resp?.status !== 200) {
    this.$utilFront.notifications(
      "Error al adjuntar archivos de Papanicolaou",
      "ERROR"
    )
    throw new Error("SaveFiles failed")
  }
},

  goBack() {
    this.$router.go(-1)
  },

async getPapReport() {
  try {
    const payload = { idStudy: this.$route.params.idStudy };
    const response = await StudyRequest.papanicolaouViewReport(payload);

    if (response.data && response.data.studyFiles.length > 0) {
      const fileData = response.data.studyFiles[0];
      this.papFilesAll.push({
        fileName: fileData.fileName,
        base64: fileData.bytes.trim(),
        fromBackend: true
      });
    }
  } catch (error) {
    console.error("Error al obtener el reporte:", error);
  }
},

openPdf(fileObj) {
    try {
      let url;
      if (fileObj.fromBackend && fileObj.base64) {
        
        const byteChars = atob(fileObj.base64);
        const byteNumbers = new Array(byteChars.length)
          .fill(0)
          .map((_, i) => byteChars.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        url = URL.createObjectURL(blob);

      } else if (fileObj.file instanceof File) {
        
        url = URL.createObjectURL(fileObj.file);

      } else {
        throw new Error("Formato de archivo no reconocido");
      }

      window.open(url, "_blank");
      
      setTimeout(() => URL.revokeObjectURL(url), 10000);

    } catch (error) {
      console.error("Error abriendo el PDF:", error);
      this.$utilFront.notifications("Error al mostrar el PDF", "ERROR");
    }
  },

  isPdf(fileName) {
      if (!fileName) return false;
      const extension = fileName.split('.').pop().toLowerCase();
      return extension === 'pdf';
    },
    removePapFile(index) {
  this.papFilesAll.splice(index, 1)
  this.newPapFiles = null
  this.fileTooLarge = false;
  this.$nextTick(() => {
    this.$refs.filesProvider.validate()
  })
},

handleFileChange(file) {
    if (this.papFilesAll.length > 0) {
      this.$utilFront.notifications(
        "Ya existe un archivo, por favor elimínalo antes de agregar otro.",
        "WARNING"
      );
      this.newPapFiles = null;
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      this.fileTooLarge = true;
      this.$utilFront.notifications(
        "El archivo excede el límite de 10 MB",
        "ERROR"
      );
      this.newPapFiles = null;
      return;
    }

    this.fileTooLarge = false;
    this.papFilesAll.push({
      file,
      fileName: file.name,
      fromBackend: false,
    });
  },
      handlePatientLoaded(patientData) {
      this.info.idPerson = patientData.person.id;
      this.info = { ...this.info, ...patientData };
      console.log("Paciente cargado:", this.info);
    },
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.prevRoute = from;
      });
    },
  };
  </script>
  